// extracted by mini-css-extract-plugin
export default {"formularz":"SzufladaFormularza_formularz__P9mum","skutek":"SzufladaFormularza_skutek__W+ynv","blad":"SzufladaFormularza_blad__EvzC-","stopka":"SzufladaFormularza_stopka__I9PaA"};